import { FormEvent, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useIntl } from "../lib/i18n";

export default function LoginPage() {
  const { session, login } = useAuth();
  const { t } = useIntl();
  const navigate = useNavigate();
  const [tenantSlug, setTenantSlug] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  if (session) return <Navigate to="/admin" replace />;

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setPending(true);
    try {
      await login(tenantSlug.trim(), email.trim(), password);
      navigate("/admin", { replace: true });
    } catch {
      setError(t("login.error"));
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="grid min-h-full place-items-center bg-brand-50 px-4">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm rounded-xl bg-white p-8 shadow-md ring-1 ring-slate-200"
      >
        <h1 className="text-xl font-semibold text-brand-900">{t("login.title")}</h1>
        <label className="mt-6 block text-sm">
          {t("login.tenantSlug")}
          <input
            value={tenantSlug}
            onChange={(e) => setTenantSlug(e.target.value)}
            className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2"
            required
          />
        </label>
        <label className="mt-4 block text-sm">
          {t("login.email")}
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2"
            required
          />
        </label>
        <label className="mt-4 block text-sm">
          {t("login.password")}
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 block w-full rounded-md border border-slate-300 px-3 py-2"
            required
          />
        </label>
        {error && <p className="mt-4 text-sm text-rose-600">{error}</p>}
        <button
          type="submit"
          disabled={pending}
          className="mt-6 w-full rounded-md bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 disabled:opacity-60"
        >
          {t("login.submit")}
        </button>
      </form>
    </div>
  );
}
